<template>
  <span
    class="bg-amber-400 text-amber-900 text-[9px] uppercase tracking-widest px-1.5 py-0.5 rounded-full font-poppins"
    title="Sample data — not yet wired to live sources"
  >
    sample
  </span>
</template>
